export default `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxOS1VT6rK4v6LuhaohWn
cErX/a+xOah+3GgCHVdQDHdUieVUFKQvjkCBuBfiwYGhvdw4rqPvlbPfi1ffNYnr
JhtEk++hG9+Ajir9KgYchN5B/ZC8Bim/FWDYDUvqSM2zLHaiT5+gSgBwMSVjYuri
rpuaMcOru5vA84KjWaVTQNNBqB1LcHAyH5ZYmrbvoKgiwRxAOItnqgImpxpHn59G
CIXZx+phgUSAxmv9QCQuklhp71Alb+mYI8nhskOzqMcL0x6dhha+GYFqLojQyaiq
YjmwwCPbXznHhPfEXG/zcfK9UU51faQbA9tTcvy6V2Vc2XEx9OKrkW+nHsSFzkO1
SQIDAQAB`
